import React from 'react';

import { Img, ImgProps } from './Img';
import { withProps } from '../../entity/components';

export const RoundImg = (props: ImgProps) => {
  return <Img src={props.src} {...withProps({ ...props, round: true })} />;
};
